module.exports = __webpack_public_path__ + "img/symbol_6.e41598c8.png";